import React from 'react';
import ReactDOM from 'react-dom';
import './episodes.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from "react-router-dom";


/* ---------------------RESOURCES--------------------- */
class Ep extends React.Component{
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div className="longerPage container-fluid">
                <span class="topButtons"><button className="eButton"><Link to="/Episodes">Episodes</Link></button><button className="hButton"><Link to="/">Home</Link></button></span>

                
                {/*Titles*/}
                <div className="row">
                    <div className="title-wrapper col-12">
                        <h1 className="title">Season 2, Episode 8: North Korea vs. South Korea — Post-WW2 and Divisions</h1>
                        <h5 className="korean-title">시즌 2, 에피소드 8: 한반도 분단</h5>
                    </div>
                </div>

                {/*VOCABULARY*/}
                <div class="vocabList">

{/* INTRO */}
1945년 — the year of 1945 <br></br>
일본제국 (il bon jae guk) — Japanese empire <br></br>
항복하다 (haeng bok ha da) — to surrender <br></br>
제2차 세계대전 — World War 2 <br></br>
끝나다 (ggeut na da) — to end <br></br>

<br></br>
{/* THE SPLIT */}
삼팔선 (sam pal son) — three eight line, which is translated to the 38th parallel in English (pictured below)<br></br>
<img className="epPic" src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/bd/Korea_DMZ.svg/1200px-Korea_DMZ.svg.png"></img><br></br>
<br></br>
나누어지다 (nah noo euh ji da) — to be divided or split <br></br>
북 (book) — North <br></br>
소련 (so ryeon) — Soviet Union, or USSR <br></br>
남 (nam) — South <br></br>
미국 (mi gook) — United States of America <br></br>
같은 편 (gat eun pyeon) — same side <br></br>
도움 (doe eum) — help <br></br>
도움 없이 (doe eum up shi) — without help <br></br>
스스로 다스리다 (sseu sseu roh da seu ri da) — to govern itself <br></br>
예정 (yae jeong) — schedule, original plan <br></br>
냉전 (naeng jeon) —Cold War <br></br>
Note: the 냉 in 냉전 means cold (think of 냉 in 냉장고 or refrigerator, which keeps something cold). The 전 in 냉전 means war (think of 전 in 전쟁, which means war) <br></br>
결국 (gyeul gook) — ultimately <br></br>
사이 (sah eeh) — relationship <br></br>
나빠지다 (na ppa ji da) — to worsen <br></br>
협상 (hyeop sang) — negotiation <br></br>

<br></br>
{/* THE WAR */}
전쟁 (jeon jaeng) — war <br></br>
이승만 (Rhee Syngman) — first elected president of South Korea (pictured below)<br></br>
<img className="epPic-sm" src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/46/Rhee_Syng-Man_in_1948.jpg/200px-Rhee_Syng-Man_in_1948.jpg"></img><br></br>
<br></br>
독립 (dok lip) — independence <br></br>
운동 (oon dong) — movement <br></br>
운동가 (oon dong ga) — activist <br></br>
똑같다 (ttok gat da) — to be the same <br></br>
해 (hae) — year <br></br>
조선민주주의인민공화국 — Democratic People's Republic of Korea <br></br>
최고 (chwae go) — best/supreme <br></br>
지도자 (ji do ja) — leader <br></br>

<br></br>
{/* DICTATOR */}
독재자 (dok jae ja) — dictator of North Korea <br></br>
엄밀히 말하자면 (um mil hi mal ha ja myeon) — technically speaking <br></br>
암살하다 (ahm sal ha da) — to assassinate <br></br>
정치인 (jung chi in) — politician <br></br>

<br></br>
{/* DEATHS */}
민간인 (min gan in) — civilian <br></br>
공산주의자 (gong san joo eeh ja) — communist <br></br>
의심 (euh shim) — suspicion <br></br>
죽였습니다 (jook yut seum ni da) — killed <br></br>

<br></br>
{/* AID */}
중국 (joong gook) — china <br></br>
유엔 (yoo en) — united nations <br></br>
인천 상륙 작전 — Operation Chromite <br></br>
목적 (mok jeok) — goal <br></br>
재탈환 (jae tal hwan) — retake <br></br>
점령하다 (jum ryeong ha da) — capture <br></br>
하지만 (ha ji man) — however <br></br>
3 백만 (sam baek man) — 3 million  <br></br>
민간인 (min gan in) – civilians <br></br>

<br></br>
{/* END */}
서울대학교 부속병원 학살 사건 and 함흥 학살 사건 are some massacres/killings that happened during the war. <br></br>
휴전 (hyoo jeon) — armistice <br></br>
제의하다 (jae eeh ha da) — to suggest <br></br>
거부하다 (guh boo ha da) — to reject <br></br>
통일 (tong il) — reunification <br></br>
희망 (hee mang) — hope <br></br>
결국 (gyul gook) — ultimately, eventually <br></br>
승인 (seung in) — acceptance/agreement <br></br>

<br></br>
{/* CONCLUSION */}
갈등 (gal deung) — conflict, tension <br></br>
암살 (ahm sal) — assassination <br></br>
시도 (si doh) — attempt <br></br>
청와대 (chung wa dae) — the Blue House where the president lives; similar to the White House in the United States (pictured below)<br></br>
<img className="epPic-m" src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/f1/Korea-Seoul-Blue_House_%28Cheongwadae%29_Reception_Center_0688%269-07_cropped.jpg/630px-Korea-Seoul-Blue_House_%28Cheongwadae%29_Reception_Center_0688%269-07_cropped.jpg"></img><br></br>
<br></br>



                </div>
                <div className="row"><div className="col-12 spacer5"></div></div>
            </div>


        )
    }
}


/* -------------------------Variables------------------------- */
function App() {
    return (
        <div>
        <Ep></Ep>
        </div>
    );
}


  const Episode = () => (
    <div className='app'>
        <App />
    </div>
  );


export default Episode;